import * as actions from '../billingBatchActions';
import moment from 'moment';

const initialFilterSettings = {
  date: moment(),
  status: [],
  driver: '',
  search: '',
  startTime: null,
  endTime: null,
  grouped: false,
  isGetInvalidLegs: false,
};

const initialState = {
  legs: [],
  legs_count: 0,
  data_count: 0,
  legsMileage: 0,
  legsCostCalculated: 0,
  legsCostFromPayer: 0,
  canClose: false,
  filterSettings: initialFilterSettings,
  loadingLegs: false,
  hardLoadingLegs: false,
  loadingBatch: true,
  page: 0,
  batch: null,
  vehicles: [],
};

const setLoading = (state, payload) => {
  state = Object.assign({}, state, {
    loadingLegs: payload,
  });

  return state;
};

const setHardLoading = (state, payload) => {
  state = Object.assign({}, state, {
    hardLoadingLegs: payload,
  });

  return state;
};

const updateLegsOnly = (state, payload) => {
  state = Object.assign({}, state, {
    legs: payload,
  });

  return state;
};

const updateLegs = (state, payload) => {
  state = Object.assign({}, state, {
    legs: payload.legs,
    legs_count: payload.legs_count,
    data_count: payload.data_count,
    legsMileage: payload.legs_mileage,
    legsCostCalculated: payload.legs_cost_calculated,
    legsCostFromPayer: payload.legs_cost_from_payer,
    vehicles: payload.vehicles,
  });

  return state;
};

const updateOneLeg = (state, payload) => {
  if (payload && payload.leg && payload.leg.batch_id == state.batch.id) {
    const dbLeg = payload.leg;

    if (state.filterSettings.grouped) {
      state.legs.forEach((trip, i) => {
        state.legs[i].billing_legs.forEach((leg, j) => {
          if (leg.id == dbLeg.id) {
            if (!dbLeg.is_removed) {
              state.legs[i].billing_legs[j] = dbLeg;
            } else {
              state.legs[i].billing_legs.splice(j, 1);
              if (state.legs[i].billing_legs.length == 0) {
                state.legs.splice(i, 1);
              }
            }
            return false;
          }
        });
      });
    } else {
      state.legs.forEach((leg, j) => {
        if (leg.id == dbLeg.id) {
          if (!dbLeg.is_removed) {
            state.legs[j] = dbLeg;
          } else {
            state.legs.splice(j, 1);
          }
          return false;
        }
      });
    }
  }

  return Object.assign({}, { ...state }, { ...state });
};

const changeFilter = (state, payload) => {
  state = Object.assign({}, state, {
    filterSettings: payload,
  });

  return state;
};

const setPage = (state, payload) => {
  state = Object.assign({}, state, {
    page: payload,
  });

  return state;
};

const updateBatch = (state, payload) => {
  state = Object.assign({}, state, {
    batch: payload.batch,
    canClose: payload.canClose,
    canReceive: payload.canReceive,
    canComplete: payload.canComplete,
  });

  return state;
};

const setDefaultFilter = (state) => {
  state = Object.assign({}, state, {
    filterSettings: initialFilterSettings,
  });

  return state;
};

const setLoadingBatch = (state, payload) => {
  state = Object.assign({}, state, {
    loadingBatch: payload,
  });

  return state;
};

export default (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actions.SET_LOADING:
      return setLoading(state, payload);
    case actions.SET_HARD_LOADING:
      return setHardLoading(state, payload);
    case actions.UPDATE_LEGS_ONLY:
      return updateLegsOnly(state, payload);
    case actions.UPDATE_LEGS:
      return updateLegs(state, payload);
    case actions.UPDATE_ONE_LEG:
      return updateOneLeg(state, payload);
    case actions.SET_LOADING_BATCH:
      return setLoadingBatch(state, payload);
    case actions.SET_DEFAULT_FILTER:
      return setDefaultFilter(state);
    case actions.UPDATE_BATCH:
      return updateBatch(state, payload);
    case actions.CHANGE_FILTER:
      return changeFilter(state, payload);
    case actions.SET_PAGE:
      return setPage(state, payload);
  }
  return state;
};
